<template>
  <h2 class="accordion-header">
    <button class="accordion-button collapsed w-100 border-top border-primary" type="button" data-bs-toggle="collapse"
    :data-bs-target="`#collapse${envio.id}`" aria-expanded="false"
    :aria-controls="`collapse${envio.id}`">
      <div class="container-fluid p-0">
        <div class="row w-100">
          <div class="col">{{ envio.id }}</div>
          <div class="col">{{ envio.expendeduria_nombre }}</div>
          <div class="col">
            <div v-if="envio.status==='enviado'" style="color: green;"><SquareCheck /> Enviado</div>
            <div v-else-if="envio.status==='pendiente'" style="color: orange;"><Square /> Pendiente</div>
            <div v-else style="color: red;"><SquareX />Cancelado</div>
          </div>
          <div class="col">{{ envio.date }}</div>  
        </div>
      </div>
    </button>
  </h2>
  <div :id="`collapse${envio.id}`" class="accordion-collapse collapse text-start">
    <div class="accordion-body">
      <div class="container-fluid p-0">
        <!-- <div class="row w-100">
          <div class="col"><CalendarClock /> {{ envio.date_return }} </div>
          <div class="col"></div>
        </div> -->
          <div class="row mt-3">
            <div class="col envio-detalles">
              <h5>Detalles del envio </h5>
              <ul class="list-group list-group-flush">
                <li v-for="item in envio.detalles.filter(d => d.tipo === 'envio')" :key="item.id" class="list-group-item d-flex justify-content-between align-items-center">
                  {{ item.producto_nombre }}
                  <span class="badge bg-primary rounded-pill">{{ item.cantidad }}</span>
                </li>
              </ul>
            </div>
            <div v-if="envio.with_return" class="col envio-detalles">
              <h5>Detalles del retorno </h5>
              <ul class="list-group list-group-flush">
                <li v-for="item in envio.detalles.filter(d => d.tipo === 'retorno')" :key="item.id" class="list-group-item d-flex justify-content-between align-items-center">
                  {{ item.producto_nombre }}
                  <span class="badge bg-primary rounded-pill">{{ item.cantidad }}</span>
                </li>
              </ul>
            </div>
          </div>
        <div class="row">
          <div class="envio-details mx-2 mt-3">
            <h5>Descripción:</h5>
              <pre class="description-text">{{ envio.description }}</pre>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col text-end">
            <button class="btn btn-sm btn-outline-primary" @click="openEditFormModal(envio)" :disabled="true">
              <Pencil />
              Editar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <EnvioFormComponent 
    :show="isEditFormModalOpen"
    :envio="editingEnvio"
    @close="handleCloseEditFormModal"
    @submit="handleSubmitEditFormModal"
  />

</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Envio } from '@/types/envioTypes';
import { defineProps } from 'vue';
import { useEnviosStore } from '@/stores/useEnvioStore';
import { Pencil, Square, SquareX } from 'lucide-vue-next';

import { Wrench, UserRound, Phone, CalendarClock } from 'lucide-vue-next';
import { Calculator, Store, SquareCheck, KeyRound } from 'lucide-vue-next';

import EnvioFormComponent from './EnvioFormComponent.vue';
import IncidentItemComponent from '../incidents/IncidentItemComponent.vue';

const props = defineProps<{ envio: Envio; }>();
const envioStore = useEnviosStore();

const isEditFormModalOpen = ref(false);
const editingEnvio = ref<Envio | null>(null);

console.log("ENVIO:")
console.log(props)

// Función para formatear la fecha y la hora
const formatDateTime = (date: string | null | undefined, time: string | null | undefined): string => {
  if (!date) return "N/A";

  let formattedDate = new Date(date).toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  
  let formattedTime = time ? time.slice(0, 5) : "";

  return time ? `${formattedDate} ${formattedTime}` : formattedDate;
};

const openEditFormModal = (envio: Envio) => {
  /* console.log("Operator Name: " + envio.operator_name) */
  editingEnvio.value = envio;
  isEditFormModalOpen.value = true;
};

const handleCloseEditFormModal = () => {
  editingEnvio.value = null;
  isEditFormModalOpen.value = false;
};

const handleSubmitEditFormModal = async () => {
  await envioStore.fetchEnvios();
};

</script>

<style scoped lang="scss">
.bordered-img {
    border: 3px solid rgb(154, 194, 255);
    /* Puedes cambiar el color y grosor del borde */
    border-radius: 10px;
    /* Opcional: agrega esquinas redondeadas */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* Opcional: agrega sombra para un efecto de elevación */
    margin: 10px;
    /* Opcional: agrega un margen alrededor de la imagen */
}

.envio-detalles {
  h5 {
    color: #2c3e50;
    font-weight: 600;
    margin-bottom: 0.8rem;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.4rem;
  }

  table {
    font-size: 0.9rem;
  }

  .list-group-item {
    font-size: 0.9rem;
  }
}

.envio-details {
    //margin-top: 10px;
    //padding: 10px;
    //background-color: #f9f9f9;
    //border: 1px solid #ddd;
    //border-radius: 5px;
    text-align: left;

    /* h5 {
      font-size: 1.1rem;
      font-weight: 600;
      margin-bottom: 8px;
    } */

    h6 {
      font-weight: 600;
      font-size: 1rem;
      font-weight: 500;
      margin-top: 10px;
    }

    h5 {
    color: #2c3e50;
    font-weight: 600;
    margin-bottom: 0.8rem;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.4rem;
  }

  p, pre {
    &::first-line {
      font-weight: 500;
    }
    
    &:empty::before {
      content: "No hay descripción disponible";
      color: #999;
      font-style: italic;
    }
  }

    pre.description-text {
    white-space: pre-wrap; /* Conserva formato original y hace wrap */
    word-break: break-word; /* Evita overflow horizontal */
    font-family: inherit; /* Mantiene fuente del sistema */
    font-size: 0.9rem;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    line-height: 1.5;
    color: #333;
  }
  }

</style>
